
import { Component, Vue } from 'vue-property-decorator'
import {
  ListDepts,
  CreateDept,
  UpdateDept,
  AddDeptMember,
  RemoveDeptMember,
  SetLeaderStatusForDept,
  ListOrgUsers,
  DisableDept,
  EnableDept,
  DeleteDept
} from '@/api/orgAdmin'
import { IsMobile } from '@/utils/check'
import { Message, MessageBox } from 'element-ui'
import { DeptType, IAllDeptInfo, IAllUserInfo, IDeptUserInfo } from '@/api/types'

@Component({
  name: 'DeptManagement'
})
export default class extends Vue {
  private listLoading = true
  private deptList: IAllDeptInfo[] = []
  private deptMaps: Map<number, IAllDeptInfo> = new Map()


  // 部门表单相关
  private dialogFormVisible = false
  private dialogStatus = ''
  private temp: IAllDeptInfo = {
    dept: {
      id: 0,
      name: '',
      deptPrefix: '',
      parentId: 0,
      status: 0,
      createTime: '',
      updateTime: '',
      type: DeptType.Other
    },
    users: [],
    children: [],
    projects: []
  }
  private rules = {
    'dept.name': [{ required: true, message: '部门名称不能为空', trigger: 'blur' }],
    // 'dept.deptPrefix': [
    //   { required: true, message: '部门前缀不能为空', trigger: 'blur' },
    //   { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' },
    //   { pattern: /^[A-Z0-9]+$/, message: '只能包含大写字母和数字', trigger: 'blur' }
    // ]
  }

  // 部门成员相关
  private memberDialogVisible = false
  private memberLoading = false
  private memberList: IDeptUserInfo[] = []
  private currentDept: IAllDeptInfo | null = null

  // 添加成员相关
  private addMemberDialogVisible = false
  private userLoading = false
  private userList: IDeptUserInfo[] = []
  private userTotal = 0
  private userListQuery = {
    keywords: [] as string[],
    pageNum: 1,
    pageSize: 10
  }
  private inputKeyword = ''

  created() {
    this.getList()
    window.addEventListener('resize', this.handleResize)
  }

  mounted() {
    this.handleResize()
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }

  private handleResize() {
    // 触发isMobile计算属性的重新计算
    this.$forceUpdate()
  }

  private resetTemp() {
    this.temp = {
      dept: {
        id: 0,
        name: '',
        deptPrefix: '',
        parentId: 0,
        status: 0,
        createTime: '',
        updateTime: '',
        type: DeptType.Other
      },
      users: [],
      children: [],
      projects: []
    }
  }

  private getList() {
    this.listLoading = true
    ListDepts().then(response => {
      this.deptList = (response.data || []).map((dept: any) => {
        return {
          dept: dept.dept || {
            id: 0,
            name: '',
            deptPrefix: '',
            parentId: 0,
            status: 0,
            createTime: '',
            updateTime: ''
          },
          users: dept.users || [],
          children: dept.children || []
        }
      })
      this.deptMaps = this.flattenDepts(this.deptList)
      if (this.currentDept) {
        this.getMemberList(this.currentDept.dept.id)
      }
      this.listLoading = false
    }).catch(() => {
      this.listLoading = false
    })
  }

  private getAllChildrenIds(deptId: number): number[] {
    const dept = this.deptMaps.get(deptId)
    if (!dept) return []
    const childrenIds: number[] = [dept.dept.id]
    if (dept.children && dept.children.length > 0) {
      dept.children.forEach(child => {
        childrenIds.push(child.dept.id)
        childrenIds.push(...this.getAllChildrenIds(child.dept.id))
      })
    }
    return childrenIds
  }

  private getAllDeptsExpectSelfAndChildren(deptId: number): IAllDeptInfo[] {
    const allDepts: IAllDeptInfo[] = []
    this.deptMaps.forEach(dept => {
      if (!this.getAllChildrenIds(deptId).includes(dept.dept.id)) {
        allDepts.push(dept)
      }
    })
    return allDepts
  }

  private flattenDepts(depts: IAllDeptInfo[], result: Map<number, IAllDeptInfo> = new Map()): Map<number, IAllDeptInfo> {
    depts.forEach(dept => {
      result.set(dept.dept.id, dept)
      if (dept.children && dept.children.length > 0) {
        this.flattenDepts(dept.children, result)
      }
    })
    return result
  }

  private handleFilter() {
    this.getList()
  }

  private handleCreate() {
    this.resetTemp()
    this.dialogStatus = 'create'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as any).clearValidate()
    })
  }

  private createData() {
    (this.$refs.dataForm as any).validate((valid: boolean) => {
      if (valid) {
        CreateDept({
          name: this.temp.dept.name,
          parentId: this.temp.dept.parentId,
          deptPrefix: this.temp.dept.deptPrefix,
          type: this.temp.dept.type
        }).then(() => {
          this.dialogFormVisible = false
          this.getList()
          Message({
            message: '创建成功',
            type: 'success',
            duration: 2000
          })
        })
      }
    })
  }

  private handleUpdate(row: IAllDeptInfo) {
    this.temp = Object.assign({}, row)
    this.dialogStatus = 'update'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as any).clearValidate()
    })
  }

  private updateData() {
    (this.$refs.dataForm as any).validate((valid: boolean) => {
      if (valid) {
        const tempData = Object.assign({}, this.temp)

        // 检查是否将部门移动到其子部门下
        const parentDept = this.deptMaps.get(tempData.dept.parentId);
        if (parentDept && this.isChildOf(parentDept.dept.id, tempData.dept.id)) {
          Message({
            message: '不能将部门移动到其子部门下',
            type: 'error',
            duration: 2000
          })
          return
        }

        UpdateDept({
          id: tempData.dept.id,
          name: tempData.dept.name,
          parentId: tempData.dept.parentId,
          deptPrefix: tempData.dept.deptPrefix,
          type: tempData.dept.type
        }).then(() => {
          this.dialogFormVisible = false
          this.getList()
          Message({
            message: '更新成功',
            type: 'success',
            duration: 2000
          })
        })
      }
    })
  }

  private getLeaders(users: IDeptUserInfo[] | undefined): IDeptUserInfo[] {
    if (!users) return []
    return users.filter(user => user.isLeader)
  }

  private handleDelete(row: IAllDeptInfo) {
    if (row.children && row.children.length > 0) {
      Message({
        message: '该部门下有子部门，不能删除',
        type: 'warning',
        duration: 2000
      })
      return
    }

    if (row.users && row.users.length> 0) {
      Message({
        message: '该部门下有成员，不能删除',
        type: 'warning',
        duration: 2000
      })
      return
    }

    MessageBox.confirm('确定要删除该部门吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      DeleteDept({ id: row.dept.id }).then(() => {
        this.getList()
        Message({
          message: '删除成功',
          type: 'success',
          duration: 2000
        })
      })
    }).catch(() => {
      // 取消删除
    })
  }

  private handleDisable(row: IAllDeptInfo) {
    MessageBox.confirm('确定要禁用该部门吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      DisableDept({ id: row.dept.id }).then(() => {
        this.getList()
        Message({
          message: '禁用成功',
          type: 'success',
          duration: 2000
        })
      })
    }).catch(() => {
      // 取消禁用
    })
  }

  private handleEnable(row: IAllDeptInfo) {
    MessageBox.confirm('确定要启用该部门吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      EnableDept({ id: row.dept.id }).then(() => {
        this.getList()
        Message({
          message: '启用成功',
          type: 'success',
          duration: 2000
        })
      })
    }).catch(() => {
      // 取消启用
    })
  }

  private handleViewMembers(row: IAllDeptInfo) {
    this.currentDept = row
    this.memberDialogVisible = true
    this.getMemberList(row.dept.id)
  }

  private getMemberList(deptId: number) {
    this.memberLoading = true
    this.memberList = this.deptMaps.get(deptId)?.users || []
    this.memberLoading = false
  }

  private handleLeaderChange(row: IDeptUserInfo) {
    if (!this.currentDept) return

    SetLeaderStatusForDept({
      deptId: this.currentDept.dept.id,
      userId: row.user.id,
      isLeader: row.isLeader
    }).then(() => {
      Message({
        message: row.isLeader ? '设置为负责人成功' : '取消负责人成功',
        type: 'success',
        duration: 2000
      })
      // 刷新部门列表以更新负责人信息
      this.getList()
    }).catch(() => {
      // 恢复原状态
      row.isLeader = !row.isLeader
    })
  }

  private handleRemoveMember(row: IDeptUserInfo) {
    if (!this.currentDept) return

    MessageBox.confirm('确定要移除该成员吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      if (this.currentDept) {
        RemoveDeptMember({
          deptId: this.currentDept.dept.id,
          userId: row.user.id
        }).then(() => {
          if (this.currentDept) {
            this.getList() // 刷新部门列表以更新成员数量
            Message({
              message: '移除成功',
              type: 'success',
              duration: 2000
            })
          }
        })
      }
    }).catch(() => {
      // 取消移除
    })
  }
  private handleAddMember() {
    this.addMemberDialogVisible = true
    this.userListQuery = {
      keywords: [],
      pageNum: 1,
      pageSize: 10
    }
    this.inputKeyword = ''
    this.getUserList()
  }

  private getUserList() {
    this.userLoading = true
    ListOrgUsers({
      keywords: this.userListQuery.keywords,
      notInDeptIds: this.currentDept ? [this.currentDept.dept.id] : [],
    }).then(response => {
      this.userList = (response.data.items || []).map((user: IAllUserInfo) => {
        return {
          user: user.user,
          isLeader: false
        }
      })
      this.userTotal = response.data.total || 0
      this.userLoading = false
    }).catch(() => {
      this.userLoading = false
    })
  }

  private handleUserFilter() {
    this.userListQuery.pageNum = 1
    this.getUserList()
  }

  private handleAddKeyword() {
    const keyword = this.inputKeyword.trim()
    if (keyword && !this.userListQuery.keywords.includes(keyword)) {
      this.userListQuery.keywords.push(keyword)
      this.inputKeyword = ''
    }
  }

  private handleRemoveKeyword(index: number) {
    this.userListQuery.keywords.splice(index, 1)
  }

  private handleAddUserToDept(row: IDeptUserInfo) {
    if (!this.currentDept) return

    AddDeptMember({
      deptId: this.currentDept.dept.id,
      userId: row.user.id,
      isLeader: row.isLeader
    }).then(() => {
      if (this.currentDept) {
        this.getUserList() // 刷新用户列表以更新已添加用户
        this.getList() // 刷新部门列表以更新成员数量
        Message({
          message: '添加成功',
          type: 'success',
          duration: 2000
        })
      }
    })
  }

  // 判断一个部门是否是另一个部门的子部门
  private isChildOf(parentId: number, childId: number ): boolean {
    const dept = this.deptMaps.get(parentId);
    if (!dept?.children || dept.children.length === 0) {
      return false;
    }

    return dept.children.some(child =>
      child.dept.id === childId || this.isChildOf(child.dept.id, childId)
    );
  }

  private handleDialogClose() {
    this.dialogFormVisible = false
    this.memberDialogVisible = false
    this.addMemberDialogVisible = false
  }

  private getDeptTypeName(type: DeptType): string {
    switch (type) {
      case DeptType.Detect:
        return '检测部门'
      case DeptType.Repair:
        return '维修部门'
      case DeptType.Other:
      default:
        return '其他部门'
    }
  }

  private getDeptTypeTag(type: DeptType): string {
    switch (type) {
      case DeptType.Detect:
        return 'primary'
      case DeptType.Repair:
        return 'success'
      case DeptType.Other:
      default:
        return 'info'
    }
  }

  private get isMobile(): boolean {
    return IsMobile()
  }
}
